import type { ToolHandle } from '@toolproof-core/genesis/_contract/_index';

import { CONSTANTS } from '@toolproof-core/lib/_data/lookups';

import type { Config } from '@/workflow/_contract/config';
import type { CosmosDataModel } from '@/workflow/_contract/cosmosData';

export function deriveSelectableToolHandleSet(args: {
    config: Config;
    cosmosData: CosmosDataModel;
}): ReadonlySet<ToolHandle> {
    const configuredToolHandles = args.config.toolSelection?.toolHandles ?? [];
    if (configuredToolHandles.length > 0) {
        return new Set(configuredToolHandles.map((toolHandle) => String(toolHandle) as ToolHandle));
    }

    return new Set(Array.from(args.cosmosData.toolMap.keys()).map((toolHandle) => String(toolHandle) as ToolHandle));
}

export function getToolSetHandles(config: Config, cosmosData: CosmosDataModel): ToolHandle[] {
    const configuredToolHandles = config.toolSelection?.toolHandles ?? [];
    if (configuredToolHandles.length > 0) {
        return configuredToolHandles.map((handle) => String(handle) as ToolHandle);
    }

    const toolResources = (cosmosData.resourcesByType[CONSTANTS.Handles.ResourceTypes.TYPE_Tool] ?? []) as Array<{ handle?: unknown }>;
    return toolResources
        .map((resource) => resource.handle)
        .filter((handle): handle is string => typeof handle === 'string' && handle.length > 0)
        .map((handle) => handle as ToolHandle);
}
